var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    fill: "url(#paint0_linear_538_813)",
    fillOpacity: 0.12,
    stroke: "url(#paint1_linear_538_813)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5815 18.4H22.5855C22.3335 18.4 22.1655 18.568 22.1655 18.82V31.98L14.6335 18.68C14.5215 18.484 14.3535 18.4 14.1295 18.4H10.6855C10.4335 18.4 10.2655 18.568 10.2655 18.82V37.58C10.2655 37.832 10.4335 38 10.6855 38H13.6815C13.9335 38 14.1015 37.832 14.1015 37.58V24.42L21.6335 37.72C21.7455 37.916 21.9135 38 22.1375 38H25.5815C25.8335 38 26.0015 37.832 26.0015 37.58V18.82C26.0015 18.568 25.8335 18.4 25.5815 18.4Z",
    fill: "url(#paint2_linear_538_813)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2057 38.364C42.7497 38.364 47.2857 33.884 47.2857 28.284C47.2857 22.656 42.7497 18.176 37.2057 18.176C31.6617 18.176 27.1257 22.656 27.1257 28.284C27.1257 33.884 31.6617 38.364 37.2057 38.364ZM37.2057 34.612C33.7057 34.612 31.0177 31.868 31.0177 28.284C31.0177 24.672 33.7057 21.928 37.2057 21.928C40.7057 21.928 43.3937 24.672 43.3937 28.284C43.3937 31.868 40.7057 34.612 37.2057 34.612Z",
    fill: "url(#paint3_linear_538_813)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_813",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_813",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_538_813",
    x1: 8,
    y1: 10,
    x2: 23.0368,
    y2: 46.2652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_538_813",
    x1: 8,
    y1: 10,
    x2: 23.0368,
    y2: 46.2652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F767C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF517B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.651304f05d63b8d80fe5f58120ca5cbe.svg";
export { ForwardRef as ReactComponent };